import firebase from 'firebase'
import {getHost, bypassCache} from '../../configs/index';
import getTimeInterval from 'selectors/timeInterval'
import getSelectedCoinObj from 'selectors/selectedCoinObj'
import {transformPriceData, transformMentions} from '../../helpers/helpers';
import moment from 'moment'

export const fetchCoinData = () => (dispatch, getState) => {
  fetchCounts()(dispatch, getState)
  fetchLatestCounts()(dispatch, getState)
  fetchPriceData()(dispatch, getState)
  fetchRedditMentions()(dispatch, getState)
}


export const fetchCounts = () => async (dispatch, getState) => {
  dispatch({ type: 'data_requested_counts' })

  const coinID = getState().ui.selectedCoin
  const startTime = getTimeInterval(getState()).start.toString()
  const untilTime = getTimeInterval(getState()).end.toString()
  const getPreciseData = getState().ui.trackedDays === 1

  if(getPreciseData){ // this is just to get the 10 min frequency data
    const ref = firebase.database().ref('counts_precise').child(coinID.toString())
    ref.orderByKey().startAt(startTime).endAt(untilTime).once('value').then( snap => {
      dispatch({ type: 'value_received_counts', payload: snap.val() })
    })
  } else {

    let url = `${getHost()}/api/get-counts/${coinID}?from=${startTime}&to=${untilTime}`
    url = bypassCache() ? url + '&nocache=true' : url
    let counts
    try {
      const response = await fetch(url)
      counts = await response.json()
    } catch(error) {
      dispatch({ type: 'value_received_counts', payload: {} })
    }
    dispatch({ type: 'value_received_counts', payload: counts })
  }
}



// fetches the last 10 counts of the precise_counts ( the high frequent counts )
// these are appended to the totalCount data, so data less delay
export const fetchLatestCounts = () => async (dispatch, getState) => {
  dispatch({ type: 'data_requested_currentCount' })
  const coinID = getState().ui.selectedCoin

  const url = `${getHost()}/api/get-current-counts/${coinID}`
  let counts
  try {
    const response = await fetch(url)
    counts = await response.json()
    // response used to be like this { 1493848: {reddit: 222, telegram: 1200}}
    // now latest counts is  like: { now: {reddit: 222, telegram: 1200} }
    // so we change 'now' to 'unix-time' back here.
    counts = {[moment().unix()]: counts.now}
  } catch(error) {

    dispatch({ type: 'value_received_currentCount', payload: {} })
  }

  dispatch({ type: 'value_received_currentCount', payload: counts })
}


//////
export const fetchPriceData = () => async (dispatch, getState) => {
  const { trackedDays } = getState().ui
  const startTimeMs = getTimeInterval(getState()).start * 1000
  const untilTimeMs = getTimeInterval(getState()).end * 1000
  const untilTime = getTimeInterval(getState()).end
  const apiSymbol = getSelectedCoinObj(getState()).apiSymbol
  const symbol = getSelectedCoinObj(getState()).symbol
  dispatch({ type: 'remove_priceData' })
  dispatch({ type: 'data_requested_priceData' })

  // let interval       = '15m'
  // trackedDays        >= 7  && (interval = '2h')
  // trackedDays        >= 30 && (interval = '4h')
  // const host         = 'https://api.bitscreener.com/api/v1/graphs/ohlc/'
  // const url          = host + `${apiSymbol}?from=${startTimeMs}&to=${untilTimeMs}&interval=${interval}&btc=true`
  const interval     = trackedDays <= 14 ? '2' : '4'
  const limit        = (Math.floor((untilTimeMs - startTimeMs) / (1000 * 60 * 60)) / interval) - 1
  const host         = 'https://min-api.cryptocompare.com/data/histohour'
  const url          = host + `?fsym=${symbol}&tsym=BTC&toTs=${untilTime}&limit=${limit}&aggregate=${interval}&aggregatePredictableTimePeriods=false`

  const response     = await fetch(url)
  const rawPriceData = (await response.json()).Data
  console.log(rawPriceData)

  const toSatoshi    = parseFloat(rawPriceData[0].open) < 0.0001 // if btc value is very small number, it needs to be in satoshi
  const priceData    = transformPriceData(rawPriceData, untilTime, toSatoshi ? 100000000 : 1)
  console.log(priceData)


  dispatch({ type: 'value_received_priceData', payload: priceData })
  dispatch({ type: 'SET_PRICE_IN_SATOSHI', payload: toSatoshi })
}

export const fetchRedditMentions = () => async (dispatch, getState) => {
  const startTime = getTimeInterval(getState()).start
  const untilTime = getTimeInterval(getState()).end
  const coin = getSelectedCoinObj(getState())
  if(coin.searchName === '-') return // the name is not specific enough, makes no sense
  const searchName = encodeURIComponent(coin.searchName || coin.name || coin.apiSymbol)

  dispatch({ type: 'remove_redditMentions' })
  dispatch({ type: 'remove_redditMentionsSub' })
  dispatch({ type: 'data_requested_redditMentions' })
  dispatch({ type: 'data_requested_redditMentionsSub' })

  // https://api.pushshift.io/reddit/term/frequency/ontology
  // https://api.pushshift.io/reddit/search/comment/?q=aurora&aggs=created_utc&frequency=day&size=0'
  const frequency = 2 // this creates buckets of 2 hours
  const urlBaseComment =    'https://api.pushshift.io/reddit/search/comment/'
  const urlBaseSubmission = 'https://api.pushshift.io/reddit/search/submission/'
  const queryParams1 = `?q=${searchName}&after=${startTime}&before=${untilTime}`
  const queryParams2 = `&aggs=created_utc&frequency=${frequency}h&size=0`
  const urlComment =    urlBaseComment + queryParams1 + queryParams2
  const urlSubmission = urlBaseSubmission + queryParams1 + queryParams2
  let dataComment = {}
  let dataSubmission = {}

  try {
    const [res1, res2] = await Promise.all([fetch(urlComment), fetch(urlSubmission)])
    const [resComment, resSubmission]  = await Promise.all([res1.json(), res2.json()])
    const _dataComment = resComment.aggs.created_utc
    const _dataSubmission = resSubmission.aggs.created_utc

    dataComment = transformMentions(_dataComment, frequency, startTime, untilTime)
    dataSubmission = transformMentions(_dataSubmission, frequency, startTime, untilTime)

  } catch (error) {
    return console.log('ERROR::REDDIT_MENTIONS', error)
  }

  dispatch({ type: 'value_received_redditMentions', payload: dataComment })
  dispatch({ type: 'value_received_redditMentionsSub', payload: dataSubmission })
}



// WEBPACK FOOTER //
// ./src/actions/listeners/counts.js